// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputField_inputField__0mt6L {
  border-radius: 12rem;
  padding: 16rem 20rem;
  background-color: #ffffff;
  border: 1px #d0d5dd solid;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputField__0mt6L {
    padding: 12rem 16rem;
  }
}
@media only screen and (max-width: 700px) {
  .InputField_inputField__0mt6L {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputField__0mt6L::placeholder {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputField__0mt6L::placeholder {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputField__0mt6L * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputField__0mt6L * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputField__0mt6L:active {
  border: 1px #344054, solid;
}
.InputField_inputField__0mt6L:hover {
  border: 1px #98a2b3, solid;
}
.InputField_inputFielderror__AHz5J {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16rem;
  line-height: 24rem;
  color: #FDA29B;
  border: 1px #F04438, solid;
}
@media only screen and (max-width: 700px) {
  .InputField_inputFielderror__AHz5J {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12rem;
    line-height: 24rem;
    color: #FDA29B;
  }
}
.InputField_inputFielderror__AHz5J * {
  color: #FDA29B;
}

.InputField_inputContainer__-zyH5 {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
.InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L {
  border-radius: 12rem;
  padding: 16rem 20rem;
  background-color: #ffffff;
  border: 1px #d0d5dd solid;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L {
    padding: 12rem 16rem;
  }
}
@media only screen and (max-width: 700px) {
  .InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L::placeholder {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L::placeholder {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L:active {
  border: 1px #344054, solid;
}
.InputField_inputContainer__-zyH5 .InputField_inputField__0mt6L:hover {
  border: 1px #98a2b3, solid;
}
.InputField_inputContainer__-zyH5 .InputField_inputFielderror__AHz5J {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16rem;
  line-height: 24rem;
  color: #FDA29B;
  border: 1px #F04438, solid;
}
@media only screen and (max-width: 700px) {
  .InputField_inputContainer__-zyH5 .InputField_inputFielderror__AHz5J {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12rem;
    line-height: 24rem;
    color: #FDA29B;
  }
}
.InputField_inputContainer__-zyH5 .InputField_inputFielderror__AHz5J * {
  color: #FDA29B;
}
.InputField_inputContainer__-zyH5 .InputField_error__44vFf {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16rem;
  line-height: 24rem;
  color: #F97066;
}`, "",{"version":3,"sources":["webpack://./src/components/InputField/ui/InputField.module.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EC6FE,oBAAA;EACA,oBAAA;EAEA,yBC/DM;EDgEN,yBAAA;EAjGA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AFEX;AC+HE;EDvIF;ICoGI,oBAAA;EDxFF;AACF;AC0HE;EDvIF;ICAE,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFgBT;AACF;ACkFE;EAzGA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AFyBX;ACwGE;EA9BA;IAzGA,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFkCT;AACF;ACoEE;EA7GA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AF2CX;ACsFE;EA1BA;IA7GA,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFoDT;AACF;ACsDE;EACE,0BAAA;ADpDJ;ACuDE;EACE,0BAAA;ADrDJ;ACwDE;EAzHA,iCCFU;EDGV,kBAAA;EACA,gBAwHmC;EAvHnC,gBAAA;EACA,kBAAA;EACA,cCcU;ED2GR,0BAAA;ADpDJ;AC6DE;EAdA;IAzHA,iCCFU;IDGV,kBAAA;IACA,gBA0HqC;IAzHrC,gBAAA;IACA,kBAAA;IACA,cCcU;EFgEV;AACF;AC4CI;EACE,cC9GM;AFoEZ;;AAnFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAsFF;AArFE;ECqFA,oBAAA;EACA,oBAAA;EAEA,yBC/DM;EDgEN,yBAAA;EAjGA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AFmGX;AC8BE;ED/HA;IC4FE,oBAAA;EDSF;AACF;ACyBE;ED/HA;ICRA,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFiHT;AACF;ACfE;EAzGA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AF0HX;ACOE;EA9BA;IAzGA,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFmIT;AACF;AC7BE;EA7GA,iCCFU;EDGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cCCS;AF4IX;ACXE;EA1BA;IA7GA,iCCFU;IDGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cCCS;EFqJT;AACF;AC3CE;EACE,0BAAA;AD6CJ;AC1CE;EACE,0BAAA;AD4CJ;ACzCE;EAzHA,iCCFU;EDGV,kBAAA;EACA,gBAwHmC;EAvHnC,gBAAA;EACA,kBAAA;EACA,cCcU;ED2GR,0BAAA;AD6CJ;ACpCE;EAdA;IAzHA,iCCFU;IDGV,kBAAA;IACA,gBA0HqC;IAzHrC,gBAAA;IACA,kBAAA;IACA,cCcU;EFiKV;AACF;ACrDI;EACE,cC9GM;AFqKZ;AA5KE;ECZA,iCCFU;EDGV,kBAAA;EACA,gBDWmC;ECVnC,gBAAA;EACA,kBAAA;EACA,cCeU;AF4KZ","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.inputField {\n  @include inputField;\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  .inputField {\n    @include inputField;\n  }\n\n  .error {\n    @include fnt(16, 24, $error-400, 500, $font-text);\n  }\n}","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputField": `InputField_inputField__0mt6L`,
	"inputFielderror": `InputField_inputFielderror__AHz5J`,
	"inputContainer": `InputField_inputContainer__-zyH5`,
	"error": `InputField_error__44vFf`
};
export default ___CSS_LOADER_EXPORT___;
